module.exports = __webpack_public_path__ + "static/media/gif.f413ad8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/overlay-icons/gif.svg
// module id = 846
// module chunks = 0